import { faDownload, faEllipsisVertical } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown } from "react-bootstrap";
import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";
import { BackupData } from "../../model/CarbonExternalModels";
import BackupDelete from "./BackupDelete";
import { requestClusterBackupDownload } from "../../model/backupRestoreApiCaller";
import { Button } from "userful-chronos-common-ui/dist";

interface IProps {
    backup: BackupData;
    disabled: boolean;
}

export default function BackupActions(props: IProps) {
    const handleDownload = () => {
        requestClusterBackupDownload(props.backup.id, getGlobalStates().keycloak.token);
    };

    return (
        <Dropdown onMouseUp={(e) => e.stopPropagation()}>
            <Dropdown.Toggle className="source-actions-menu-toggle" as={Button} disabled={props.disabled}>
                <FontAwesomeIcon icon={faEllipsisVertical} />
            </Dropdown.Toggle>

            <Dropdown.Menu
                className="userful-icon-dropdown-menu"
                popperConfig={{ strategy: "fixed" }}
                renderOnMount={true}
                onKeyDown={(e) => e.stopPropagation()}
                onKeyUp={(e) => e.stopPropagation()}
            >
                {props.backup.status !== "ERROR" && props.backup.status !== "UNEXPECTED_PROCESSING_DELAY" && (
                    <>
                        <Dropdown.Item onClick={(e) => handleDownload()}>
                            <div className="gcm-icon-dropdown-menu-icon-container">
                                <FontAwesomeIcon icon={faDownload} />
                            </div>
                            <p>Download</p>
                        </Dropdown.Item>
                        <hr />
                    </>
                )}
                <BackupDelete backup={props.backup} />
            </Dropdown.Menu>
        </Dropdown>
    );
}
